module.exports = "https://r.nearpod.com/assets/media/image/oeq_icon-52d58beb3eb21d27852c07a588c502ab.svg";